module.exports = __webpack_public_path__ + "img/whatsapp-icon.f5f54744.svg";